import Constants from '../constants/Constants';
import BaseStore from './BaseStore';

const ClientWebsiteStore = new BaseStore({
    defaultData: []
});

ClientWebsiteStore.register(Constants.api.WEBSITE_LIST, function (payload) {
    const action = payload.action;

    if (action.state === Constants.request.PENDING) {
        this._loading = true;

        return true;
    }

    if (action.state === Constants.request.FINISHED) {
        this._loading = false;

        const websites = action.response.body.websites;

        // domains.sort(function (lhs, rhs) {
        //     return lhs.domain.localeCompare(rhs.domain);
        // });

        this.setData(websites);

        return true;
    }
});

module.exports = ClientWebsiteStore;



// WEBPACK FOOTER //
// ./app/stores/ClientWebsiteStore.js